/*
 * Title-cases headings that the theme capitalizes with CSS (text-transform: capitalize),
 * keeping minor words lowercase ("a", "the", "at", "on", ...). CSS alone can't skip words.
 * The CSS rule stays as a fallback; once a heading is processed its transform is turned off.
 */
(function () {
  const MINOR_WORDS = new Set([
    'a', 'an', 'the',
    'and', 'but', 'or', 'nor', 'for', 'so', 'yet',
    'as', 'at', 'by', 'in', 'of', 'off', 'on', 'per', 'to', 'up', 'via', 'vs', 'vs.',
    'from', 'into', 'onto', 'over', 'with',
  ]);
  const HEADING_SELECTOR = 'h1, h2, h3, h4, h5, h6, .h0, .h1, .h2, .h3, .h4, .h5, .h6';
  const WORD_PATTERN = /[A-Za-z][A-Za-z0-9'’.]*/g;

  function capitalize(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }

  function isAllCaps(word) {
    return word.length > 1 && word === word.toUpperCase();
  }

  function titleCase(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);

    const totalWords = textNodes.reduce((count, node) => count + (node.nodeValue.match(WORD_PATTERN) || []).length, 0);
    let wordIndex = 0;
    let startsPhrase = true;

    textNodes.forEach((node) => {
      const text = node.nodeValue;
      let lastEnd = 0;
      const updated = text.replace(WORD_PATTERN, (word, offset) => {
        // A colon, dash or opening bracket before this word starts a new phrase.
        if (/[:—–(\[]\s*$|\s-\s*$/.test(text.slice(lastEnd, offset))) startsPhrase = true;
        lastEnd = offset + word.length;

        const isFirst = wordIndex === 0 || startsPhrase;
        const isLast = wordIndex === totalWords - 1;
        wordIndex += 1;
        startsPhrase = false;

        const isHyphenated = text.charAt(offset - 1) === '-' || text.charAt(offset + word.length) === '-';

        if (isAllCaps(word)) return word;
        if (!isFirst && !isLast && !isHyphenated && MINOR_WORDS.has(word.toLowerCase())) return word.toLowerCase();
        return capitalize(word);
      });
      if (/[:—–]\s*$/.test(text)) startsPhrase = true;
      if (updated !== text) node.nodeValue = updated;
    });

    // !important so it wins over the theme's `text-transform: capitalize !important` heading rules.
    element.style.setProperty('text-transform', 'none', 'important');
  }

  function process(root) {
    const headings = [];
    if (root.matches && root.matches(HEADING_SELECTOR)) headings.push(root);
    if (root.querySelectorAll) headings.push(...root.querySelectorAll(HEADING_SELECTOR));
    const parentHeading = root.parentElement && root.parentElement.closest(HEADING_SELECTOR);
    if (parentHeading) headings.push(parentHeading);

    headings.forEach((heading) => {
      if (heading.style.textTransform === 'none' && !heading.dataset.titleCase) return;
      if (getComputedStyle(heading).textTransform !== 'capitalize' && !heading.dataset.titleCase) return;
      heading.dataset.titleCase = 'true';
      titleCase(heading);
    });
  }

  function init() {
    process(document.body);

    // Headings added later (cart drawer, quick add, variant changes, section rendering).
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) process(node);
          else if (node.nodeType === Node.TEXT_NODE && node.parentElement) process(node.parentElement);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
